// Live blog data from the CMS (/api/blogs), with the static blogs.js as a
// graceful fallback so the site never breaks if the backend is unreachable.
import { useState, useEffect } from "react";
import { BLOGS, getBlog } from "./blogs";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const byNumber = (a, b) => (parseInt(a.number, 10) || 0) - (parseInt(b.number, 10) || 0);

let _cache = null;
let _promise = null;

export const invalidateBlogs = () => { _cache = null; _promise = null; };

export const loadBlogs = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${API}/blogs`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((d) => {
        const list = (d.blogs || []).slice().sort(byNumber);
        _cache = list.length ? list : BLOGS;
        return _cache;
      })
      .catch(() => {
        _cache = BLOGS;
        return BLOGS;
      });
  }
  return _promise;
};

export const useBlogs = () => {
  const [blogs, setBlogs] = useState(_cache || BLOGS);
  useEffect(() => {
    let alive = true;
    loadBlogs().then((b) => alive && setBlogs(b));
    return () => { alive = false; };
  }, []);
  return blogs;
};

export const useBlog = (slug, previewToken) => {
  const [state, setState] = useState(() => {
    const cached = !previewToken && _cache && _cache.find((b) => b.slug === slug);
    return { loading: !cached, blog: cached || null };
  });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    const url = previewToken
      ? `${API}/preview/blog/${slug}?token=${encodeURIComponent(previewToken)}`
      : `${API}/blogs/${slug}`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((b) => { if (alive) setState({ loading: false, blog: b || (previewToken ? null : getBlog(slug)) || null }); })
      .catch(() => { if (alive) setState({ loading: false, blog: (previewToken ? null : getBlog(slug)) || null }); });
    return () => { alive = false; };
  }, [slug, previewToken]);
  return state;
};
